import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;

/**
 * Loads Google Analytics 4 (gtag.js) once and tracks SPA route changes.
 * Reads the Measurement ID from REACT_APP_GA_ID. Skips loading if unset.
 */
export default function GoogleAnalytics() {
  const location = useLocation();
  const loaded = useRef(false);

  useEffect(() => {
    if (!GA_ID) return;
    if (loaded.current) return;
    loaded.current = true;

    // Inject gtag.js script
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    // Initialise dataLayer + gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    // Disable auto page_view; we will send manually on route change
    gtag("config", GA_ID, { send_page_view: false });
  }, []);

  useEffect(() => {
    if (!GA_ID || !window.gtag) return;
    const page_path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  return null;
}
